@if(inlineComponent){
  <mat-form-field [appearance]="'none'" [class]="'app__table--form--field w-[98%]'">
    <mat-select
      #templateItemDropdown
      [placeholder]="placeholder"
      [disableOptionCentering]="true"
      [panelClass]="'income__expense--refund--category--dropdown transaction__income--expense--panel'"
      (closed)="closeDropDownEvent($event)"
      >
      <div>
        <div class="mx-2 my-3 h-10">
          <div class="income__expense--category--header items-center justify-around h-full">
            <mat-form-field appearance="fill" class="w-full app__attributes-search-field">
              <input
                #myInput
                matInput
                type="text"
                class="w-[80%] pl-[10px]"
                [(ngModel)]="searchText"
                autocomplete="off"
                [placeholder]="'Search Template'"
                (keydown.space)="$event.stopPropagation()"
                />
              </mat-form-field>
              <mat-icon class="text-[#C2C3C7]">search</mat-icon>
            </div>
          </div>

          @if (linkedItems.length) {
            <div class="income__expense--category--list bg-transparent max-h-[196px] min-h-[80px]">
              @if((linkedItems | filterWorkspace : searchText).length){
                @for (item of linkedItems | filterWorkspace : searchText; track item) {
                  <mat-option [value]="item.name" (click)="selectTaskItem(item)">
                    <div class="flex items-center app__text--overflow hover:cursor-pointer">
                      <img src="{{ item.vault_form_id | formIcon : stateObject.forms }}" width="24px !important;" height="24px !important;" />
                      <span class="w-[80%] ml-2" appTooltip [toolTipText]="item.form_name"> {{ item.form_name | capitalizeFirstWord }} </span>
                    </div>
                  </mat-option>
                }
                }@else{
                <mat-option> No results found </mat-option>
              }
            </div>
          } @else {
            <div class="income__expense--category--list bg-transparent h-[196px]">
              @for (count of loader; track count) {
                <mat-option>
                  <div class="ph-item border-none w-full h-3">
                    <div class="ph-col-12 p-0">
                      <div class="ph-row">
                        <div class="ph-col-12 h-3"></div>
                      </div>
                    </div>
                  </div>
                </mat-option>
              }
            </div>
          }
        </div>
      </mat-select>
    </mat-form-field>
  } @else{
    <div class="dialog-container">
      @if (data.triggeredFrom == 'transaction-register' || (data.triggeredFrom == 'all-transaction-register' && !data.linked_vault_user_form_id)) {
        <div
          [class]="data.triggeredFrom == 'all-transaction-register' ? 'mb-5' : ''"
          >
          <div class="mt-1 search__task-input">
            <input type="text" class="form-control text-sm" id="search-text" aria-describedby="search-text" [(ngModel)]="searchText" autofocus #search />
            <i (click)="searchItem(search.value)" class="material-icons">search</i>
          </div>
          @if (linkedItems) {
            <div class="task__item-list mt-4 ml-1">
              @if (searchText !== '') {
                <p style="color: rgb(198, 193, 193); font-size: 15px">
                  {{ (linkedItems | filterWorkspace : searchText).length == 0 ? 'No results found' : '' }}
                </p>
              }
              @for (item of linkedItems | filterWorkspace : searchText; track item) {
                <ul>
                  <li class="d-flex justify-content-between" (click)="selectTaskItem(item)">
                    <div class="d-flex pl-3">
                      <img src="{{ item.vault_form_id | formIcon : stateObject.forms }}" width="24px !important;" height="24px !important;" />
                      <p class="pl-3 form-name" matTooltip="{{ item.form_name.length > 20 ? item.form_name : null }}" matTooltipClass="customeTooltip">
                        {{ item.form_name | truncateStrPipe : 20 }}
                      </p>
                    </div>
                    <p mat-line>
                      <small> Last updated {{ item.updated_at | date }}</small>
                    </p>
                  </li>
                </ul>
              }
            </div>
          } @else {
            <div class="ph-item" style="padding: 0px !important; width: 100%; background-color: white; height: 100%; border: 0px; margin-top: 35px">
              <div class="ph-col-12" style="padding: 0px !important">
                <div class="ph-row">
                  <div class="ph-col-6"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-4"></div>
                </div>
                <div class="ph-row mt-2">
                  <div class="ph-col-6"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-4"></div>
                </div>
                <div class="ph-row mt-2">
                  <div class="ph-col-6"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-4"></div>
                </div>
                <div class="ph-row mt-2">
                  <div class="ph-col-6"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-4"></div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (data.triggeredFrom == 'all-transaction-register' && data.linked_vault_user_form_id) {
        <div class="mt-[-14px] mb-[6px] mx-[-14px]">
          <div class="app__between--justified--content">
            <div class="app__between--justified--content app__form--attribute--card w-[330px] py-2 ml-0 mr-0">
              <span class="text-[13px]">{{ data?.linked_vault_user_form_name | truncateStrPipe : 35 }} </span>
              <span class="material-icons f20 cursor-pointer text-[#25508e]" (click)="editLinkedVaultUserForm()"> edit </span>
            </div>
            <span class="material-icons pt-[6px] f20 cursor-pointer text-[#707070]" (click)="deleteLinkedVaultUserForm()"> delete </span>
          </div>
        </div>
      }

    </div>
    <!-- <div class="footer" *ngIf="showFooter || data.triggeredFrom == 'transaction-register'" style="position: sticky; bottom: 0px">
    <p class="footer-title">Can’t find the right file? Create a new one</p>
  (click)="openDrawerEvent(-1, 'All', $event)
  <button class="footer-invite-btn"
  (click)="openDrawerEventRegister($event)
  
  ">{{ 'Create File' | titlecase }}</button>

    [matMenuTriggerFor]="menuItem1"
    <mat-menu #menuItem1="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
      <button mat-menu-item class="popup-menu-item" (click)="addFile('is_document', 'Documents')">
        <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">insert_drive_file</span>Document</p>
      </button>

      <button mat-menu-item class="popup-menu-item" (click)="addFile('is_account', 'Accounts')">
        <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">perm_contact_calendar</span>Account</p>
      </button>

      <button mat-menu-item class="popup-menu-item" (click)="addFile('is_possession', 'Possessions')">
        <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">home</span>Possession</p>
      </button>
      <button mat-menu-item class="popup-menu-item" (click)="addFile('is_location', 'Locations')">
        <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">location_on</span>Location</p>
      </button>
    </mat-menu>
  </div> -->

  <!-- <div class="template-container" *ngIf="drawerButtonClicked">
  <view-template [is_filter]="is_filter" [group_id]="group_id" [is_filter_name]="is_filter_name"></view-template>
</div> -->
}
